import { FinancialJuiceWidget } from './FinancialJuiceWidget';

interface EconomicCalendarWidgetProps {
  onRemove: () => void;
}

export function EconomicCalendarWidget({ onRemove }: EconomicCalendarWidgetProps) {
  return (
    <FinancialJuiceWidget
      widgetType="ECOCAL"
      mode="standard"
      title="Economic Calendar"
      onRemove={onRemove}
    />
  );
}
